import {
  getPredityPropertyAdditionnalData as getData,
  getPredityPropertyControllersData as getDataControllers,
  getPredityPropertiesAdditionnalData as getDatas,
} from '@/services/api/internal/heatingIgnition/assets_predity_properties.api';

export function getPredityPropertyAdditionnalData(items) {
  const idList = items.map((item) => item.id);
  Promise.all(idList.map((id) => getData(id))).then((responses) => {
    console.log('reponses : ', responses);
  });
  return items;
}
export function getPredityPropertyControllersData(item) {
  return getDataControllers(item);
}
export function getPredityPropertiesAdditionnalData(items) {
  const idList = items.map((item) => item.id);
  return getDatas(idList);
}
